import * as React from 'react';
import store from '../../store';

export const MyLoadingComponent = (): React.ReactNode => {
    return <div className="component-loading" style={{height: store.status.isShowHead ? '89vh' : '91vh'}}/>;
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/loadable/index.tsx